import type { MentorCategory } from "../../types/hackathon";

export interface MentorGroupDef {
  id: string;
  title: string;
  intro: string;
  categories: MentorCategory[];
  /** portrait tile colours — always paired for contrast */
  tile: string;
  /** optional coloured panel behind the whole group, with text colours that read on it */
  panel?: GroupPanel;
}

export interface GroupPanel {
  bg: string;
  border: string;
  heading: string;
  accent: string;
  body: string;
  muted: string;
}

export const mentorGroups: MentorGroupDef[] = [
  {
    id: "mentors",
    title: "Mentors",
    intro: "Advisors, not team members. Bring a specific problem, a sketch or a decision you're stuck on.",
    categories: ["mentor"],
    tile: "bg-sun text-ink",
  },
  {
    id: "office-hours",
    title: "Office hours",
    intro: "Go-to-market, cross-border and idea-stage experts. Virtual unless noted; all times Pacific.",
    categories: ["office-hours"],
    tile: "bg-cream text-ink",
  },
  {
    id: "investor-sponsor",
    title: "Investor & sponsor",
    intro: "Pressure-test the business case and the path from prototype to production.",
    categories: ["investor", "sponsor"],
    tile: "bg-brgreen text-cream",
  },
  {
    id: "link-hosts",
    title: "Link School of Business hosts",
    intro:
      "A college fully dedicated to entrepreneurship, with campuses in Brazil and Miami designed for founders to learn, connect, and build companies.",
    categories: ["link-host"],
    tile: "bg-sun text-ink",
    panel: {
      bg: "bg-lsbblue",
      border: "border-sun",
      heading: "text-cream",
      accent: "text-sun",
      body: "text-cream/85",
      muted: "text-cream/70",
    },
  },
  {
    id: "hosts",
    title: "Circuit Launch hosts",
    intro:
      "A cofacturing facility for hardware and mechatronic engineering, helping companies build physical products and teaching the next generation of mechatronic engineers.",
    categories: ["host"],
    tile: "bg-cream text-ink",
    panel: {
      bg: "bg-clteal",
      border: "border-ink",
      heading: "text-ink",
      accent: "text-ink",
      body: "text-ink/85",
      muted: "text-ink/70",
    },
  },
];

const labels: Record<MentorCategory, string> = {
  judge: "Demo Day judge",
  mentor: "Mentor",
  "office-hours": "Office hours",
  investor: "Investor mentor",
  sponsor: "Sponsor mentor",
  host: "Circuit Launch host",
  "link-host": "Link School of Business host",
};

export function categoryLabel(c: MentorCategory | undefined): string {
  return labels[c ?? "mentor"];
}
